import { useQuery } from "react-query";
import { API_KEY_GET_FRODERS_LIST } from "../constants";
import { getFrodersList } from "../api";

export const useGetFrodersList = (params) => {
  return useQuery([API_KEY_GET_FRODERS_LIST, params], () => getFrodersList(params));
};
